import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"
import Filters from "components/Common/Filters"
import Paginations from "components/Common/Paginations"
import { filters } from "components/Common/constants"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import TableShimmer from "components/Shared/TableShimmer"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap"
import { showAlert } from "store/reducers/alertReducer"
import {
  deleteStaticMaintenance,
  getStaticMaintenance
} from "store/actions/staticMaintenanceAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"

const StaticMaintenance = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Static Maintenance List ")

  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const pageNumber = parseInt(searchParams.get("page")) || 1

  const {
    loading,
    isLoading,
    totalCount,
    totalPages,
    currentPage,
    itemsPerPage,
    staticMaintenance,
  } = useSelector(state => state.StaticMaintenance)

  const { userRole, accountType } = useSelector(state => state.Login)
  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      41,
      "static_maintenance_1",
      accountType
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      41,
      "static_maintenance_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      41,
      "static_maintenance_3",
      accountType
    )
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      41,
      "static_maintenance_4",
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole])

  const [isApiCalled, setIsApiCalled] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [selectedFilters, setSelectedFilters] = useState({
    sortOrder: 1,
  })

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }
  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  useEffect(() => {
    fetchAllStaticMaintenance()
  }, [])

  const fetchAllStaticMaintenance = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      orderBy: 1,
      keyword: "",
    }
    dispatch(getStaticMaintenance(payload))
    setIsApiCalled(true)
  }

  const getApiCall = (page = 1) => {
    const { sortOrder } = selectedFilters
    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
    }

    return dispatch(getStaticMaintenance(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/static-maintenance?page=${page}`)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  const handleSearch = () => {
    getApiCall() // Default to page 1 for the initial search
  }

  const onPageChange = page => {
    getApiCall(page) // Use the specific page number for pagination
  }

  const handleReset = () => {
    setSearchTerm("")
    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      orderBy: 1,
      keyword: "",
    }
    dispatch(getStaticMaintenance(payload))
    navigate(`/static-maintenance/?page=${1}`)
    setSelectedFilters({
      sortOrder: 1,
    })
  }

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
    }
    dispatch(deleteStaticMaintenance(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowDeleteModal(false)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Static Maintenance Lists")}
                isAddBtn={loading ? false : usersPermissions.create}
                addBtnText={t("Add Static Maintenance")}
                onAddBtnClick={() => navigate("/static-maintenance/add")}
              />
              <CardBody>
                <Filters
                  filters={[filters[1]]}
                  searchTerm={searchTerm}
                  handleSearchChange={handleSearchChange}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                  searchBy={t("Name")}
                />

                <div className="table-responsive">
                  {loading ? (
                    <TableShimmer row={7} col={5} />
                  ) : staticMaintenance.length === 0 ? (
                    <p className="text-center my-3">
                      {t("No static maintenance found")}
                    </p>
                  ) : (
                    <Table className="table mb-0" hover>
                      <thead className="table-light">
                        <tr>
                          <th className="table-col-sn">{t("S. No.")}</th>
                          <th>{t("CODE")}</th>
                          <th>{t("VALUE")}</th>
                          <th>{t("TYPE")}</th>
                          <th className="text-center">
                            <span
                              className="d-inline-block"
                            >
                              {t("Action")}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {staticMaintenance.map((item, index) => (
                          <tr
                            key={item._id}
                            onClick={() => {
                              navigate(
                                ``
                              )
                            }}
                            className="cursor-pointer"
                          >
                            <th scope="row">
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </th>
                            <td>{item.code}</td>
                            <td>
                              {item.value === null || item.value === undefined ? (
                                <span className="text-muted">-</span>
                              ) : typeof item.value === 'boolean' ? (
                                <span className={`badge ${item.value ? 'bg-success' : 'bg-danger'}`}>
                                  {item.value ? 'TRUE' : 'FALSE'}
                                </span>
                              ) : typeof item.value === 'number' ? (
                                item.value.toString()
                              ) : (
                                item.value.toString()
                              )}
                            </td>
                            <td>{item.type?.toString().toUpperCase() || '-'}</td>

                            <td className="text-center">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  tag="a"
                                  className="card-drop"
                                  onClick={e => e.stopPropagation()}
                                >
                                  <i className="mdi mdi-dots-vertical font-size-18"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                  {usersPermissions.edit && (
                                    <DropdownItem
                                      onClick={e => {
                                        e.stopPropagation()
                                        navigate(
                                          `/static-maintenance/edit?id=${item._id}`
                                        )
                                      }}
                                    >
                                      <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                                      {t("Edit")}
                                    </DropdownItem>
                                  )}
                                  {usersPermissions.delete && (
                                    <DropdownItem
                                      onClick={e => {
                                        e.stopPropagation()
                                        setItemIdToDelete(item._id)
                                        setShowDeleteModal(true)
                                      }}
                                    >
                                      <i className="mdi mdi-trash-can font-size-16 text-danger me-1"></i>
                                      {t("Delete")}
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                            {/* )} */}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
                {!loading && staticMaintenance.length > 0 && (
                  <div className="mt-3">
                    <Paginations
                      data={staticMaintenance}
                      itemsPerPage={itemsPerPage}
                      onPageChange={onPageChange}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <DeleteModal
        show={showDeleteModal}
        isLoading={isLoading}
        onDeleteClick={handleDelete}
        onCloseClick={() => setShowDeleteModal(false)}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: t("Static Maintenance"),
        })}
      />
    </div>
  )
}

export default StaticMaintenance
